var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['loading', { 'loading-opacity': _vm.hasOpacity }],style:(_vm.loadingStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }